import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordDetailToolbarPrimaryComponent extends Component {
  // Services
  @service abilities;
  @service recordLocks;
  @service recordStatus;

  // Getter and setter
  get isPublishable() {
    return (
      this.args.model.cmsState &&
      this.args.model.cmsState != 2 &&
      this.args.actions.onPublish
    );
  }

  get isMlp() {
    return getRecordType(this.args.model) === 'mlp';
  }

  get canUpdateOrCreate() {
    let action = this.args.model.isNew ? 'create' : 'update';

    return this.abilities.can(action, this.args.model);
  }

  get isDisabled() {
    return this.recordStatus.isDisabled(this.args.model);
  }

  get isCancelDisabled() {
    const model = this.args.model;

    return Boolean(
      this.recordLocks.isLocking(model) ||
      this.recordStatus.isPublishing(model) ||
      model.isSaving ||
      model.validations?.isValidating,
    );
  }

  // Template
  <template>
    {{#if this.canUpdateOrCreate}}
      {{#if @actions.onPreview}}
        <Button
          @style='outline'
          @label={{t 'record_detail.toolbar.primary.preview'}}
          @icon='preview'
          @disabled={{this.isDisabled}}
          {{on 'click' @actions.onPreview}}
        />
      {{/if}}

      {{#if (or this.isMlp this.isPublishable)}}
        <Button
          @style='outline'
          @label={{t 'record_detail.toolbar.primary.publish'}}
          @icon='publish'
          @tooltip={{if
            @model.hasUnpublishedChanges
            null
            (t 'record_detail.toolbar.primary.already_published')
          }}
          @disabled={{or this.isDisabled (not @model.hasUnpublishedChanges)}}
          {{on 'click' @actions.onPublish}}
        />
      {{/if}}

      {{#if @actions.onSave}}
        <Button
          @disabled={{this.isDisabled}}
          @icon='save'
          @label={{t 'record_detail.toolbar.primary.save'}}
          {{on 'click' @actions.onSave}}
        />
      {{/if}}
    {{/if}}

    <Button
      @style='grey'
      @disabled={{this.isCancelDisabled}}
      @icon='close'
      {{on 'click' @actions.onCancel}}
    />
  </template>
}
